// Trilingual content for ADHD School — English / Odia / Hindi
// Keep keys flat with dot-notation accessed via t(key)

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "od", label: "ଓଡ଼ିଆ", short: "OD" },
  { code: "hi", label: "हिन्दी", short: "HI" },
];

export const translations = {
  en: {
    "brand.school": "Aachary Dev Development Holistic (ADHD) School",
    "brand.short": "ADHD School",
    "brand.tagline": "Empowering Every Child Through Education, Care & Holistic Development",
    "brand.physio": "Bhadrak Physiotherapy & Rehab Centre",

    "nav.home": "Home",
    "nav.about": "About",
    "nav.services": "Services",
    "nav.principal": "Principal",
    "nav.physio": "Physiotherapy",
    "nav.doctor": "Doctor",
    "nav.gallery": "Gallery",
    "nav.events": "Events",
    "nav.contact": "Contact",
    "nav.enquire": "Admission Enquiry",

    "cta.enquire": "Admission Enquiry",
    "cta.call": "Call Now",
    "cta.principal": "Meet Our Principal",
    "cta.doctor": "Meet Dr. Manas Ranjan Jena",
    "cta.location": "View Location",
    "cta.whatsapp": "WhatsApp Us",
    "cta.directions": "Get Directions",
    "cta.brochure": "Download Prospectus",
    "cta.viewAll": "View All",
    "cta.readMore": "Read More",
    "cta.submit": "Submit Enquiry",

    "hero.eyebrow": "Bhadrak, Odisha",
    "hero.headline": "Where Every Child's Potential Becomes Possibility.",
    "hero.subheading": "Special education, therapy services, and holistic personality development — guided by experienced teachers and certified therapists.",
    "hero.rating": "Rating",
    "hero.reviews": "Reviews",
    "hero.statTherapies": "5 Therapy Programs",
    "hero.statYears": "Trusted by Bhadrak Families",

    "about.title": "Why Parents Trust ADHD School",
    "about.body": "Aachary Dev Development Holistic School is one of the leading centers in Bhadrak dedicated to children's education, therapy, and overall personality development. We believe every child is unique and deserves individual attention, compassionate guidance, and opportunities to reach their full potential.",
    "about.pillarsTitle": "What we focus on",

    "services.title": "Our Therapy & Education Services",
    "services.subtitle": "Five integrated programs designed around the child — not the other way around.",

    "principal.title": "Meet Our Principal",
    "principal.name": "Swasti Prava Jena",
    "principal.role": "Principal & Founder",
    "principal.qualifications": "B.A., NTT (Nursery Teacher Training), Nursing Trained Teacher",
    "principal.certs": "Certified in ADHD Management & Autism Support and Care",
    "principal.quote": "Our vision is to nurture every child with love, care, and holistic education so they can become confident, responsible, and successful individuals.",

    "faq.title": "Why Parents Choose ADHD School",
    "faq.subtitle": "The questions every parent asks — answered honestly.",

    "reviews.title": "What Parents Say",
    "reviews.subtitle": "Real stories from Bhadrak families.",

    "physio.eyebrow": "Second specialty",
    "physio.title": "Bhadrak Physiotherapy & Rehab Centre",
    "physio.tagline": "Care, Therapy & Rehabilitation for Better Health",
    "physio.servicesTitle": "Physiotherapy & Rehabilitation Services",
    "physio.reviewsTitle": "Patient Reviews",

    "doctor.title": "Meet The Doctor",
    "doctor.name": "Dr. Manas Ranjan Jena",
    "doctor.role": "Consultant & Parent Counselor",
    "doctor.description": "Providing expert consultation and guidance for parents and children with compassion and dedication. We believe in patient-first care and holistic rehabilitation.",

    "gallery.title": "A Glimpse Inside Our School",
    "gallery.subtitle": "Moments of learning, therapy and joy at ADHD School.",

    "events.title": "Events & Activities",
    "events.subtitle": "Workshops, awareness camps and celebrations through the year.",

    "contact.title": "Visit Us",
    "contact.subtitle": "We'd love to welcome you for a campus tour.",
    "contact.address": "Bonth Chhak, Netaji Nagar Road, Near LIC Office, Bagurai, Bhadrak, Odisha – 756100",
    "contact.phoneLabel": "Phone",
    "contact.addressLabel": "Address",
    "contact.hoursLabel": "Hours",
    "contact.hours": "Mon – Sat · 9:00 AM – 6:00 PM",

    "form.title": "Admission Enquiry",
    "form.subtitle": "Tell us about your child. We'll get back within one working day.",
    "form.name": "Parent / Guardian Name",
    "form.phone": "Phone Number",
    "form.email": "Email (optional)",
    "form.childAge": "Child's Age (optional)",
    "form.type": "Enquiry Type",
    "form.typeAdmission": "School Admission",
    "form.typePhysio": "Physiotherapy",
    "form.typeGeneral": "General Question",
    "form.message": "Your Message",
    "form.success": "Thank you! We'll call you shortly.",
    "form.error": "Something went wrong. Please call us directly.",

    "footer.quickLinks": "Quick Links",
    "footer.contact": "Reach Us",
    "footer.copyright": "All Rights Reserved.",
    "footer.builtBy": "Designed with care for the children of Bhadrak.",
  },

  od: {
    "brand.school": "ଆଚାର୍ଯ୍ୟ ଦେବ ଡେଭଲପମେଣ୍ଟ ହୋଲିଷ୍ଟିକ୍ ସ୍କୁଲ୍",
    "brand.short": "ADHD ସ୍କୁଲ୍",
    "brand.tagline": "ଶିକ୍ଷା, ଯତ୍ନ ଓ ସମଗ୍ର ବିକାଶ ମାଧ୍ୟମରେ ପ୍ରତ୍ୟେକ ଶିଶୁକୁ ଶକ୍ତିଶାଳୀ କରିବା",
    "brand.physio": "ଭଦ୍ରକ ଫିଜିଓଥେରାପି ଏବଂ ରିହାବ୍ ସେଣ୍ଟର",

    "nav.home": "ମୂଳପୃଷ୍ଠା",
    "nav.about": "ଆମ ବିଷୟରେ",
    "nav.services": "ସେବାସମୂହ",
    "nav.principal": "ପ୍ରଧାନ ଶିକ୍ଷୟିତ୍ରୀ",
    "nav.physio": "ଫିଜିଓଥେରାପି",
    "nav.doctor": "ଡାକ୍ତର",
    "nav.gallery": "ଗ୍ୟାଲେରୀ",
    "nav.events": "ଅନୁଷ୍ଠାନ",
    "nav.contact": "ଯୋଗାଯୋଗ",
    "nav.enquire": "ଆଡମିଶନ ପଚାରନ୍ତୁ",

    "cta.enquire": "ଆଡମିଶନ ପଚାରନ୍ତୁ",
    "cta.call": "ଏବେ କଲ କରନ୍ତୁ",
    "cta.principal": "ପ୍ରଧାନ ଶିକ୍ଷୟିତ୍ରୀଙ୍କୁ ଭେଟନ୍ତୁ",
    "cta.doctor": "ଡାକ୍ତର ମନସ ରଞ୍ଜନ ଜେନାଙ୍କୁ ଭେଟନ୍ତୁ",
    "cta.location": "ସ୍ଥାନ ଦେଖନ୍ତୁ",
    "cta.whatsapp": "ୱାଟ୍ସଆପ୍ କରନ୍ତୁ",
    "cta.directions": "ଦିଗ ଦେଖନ୍ତୁ",
    "cta.brochure": "ବ୍ରୋସର ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
    "cta.viewAll": "ସବୁ ଦେଖନ୍ତୁ",
    "cta.readMore": "ଅଧିକ ପଢ଼ନ୍ତୁ",
    "cta.submit": "ପଚାରନ୍ତୁ",

    "hero.eyebrow": "ଭଦ୍ରକ, ଓଡ଼ିଶା",
    "hero.headline": "ଯେଉଁଠି ପ୍ରତ୍ୟେକ ଶିଶୁର ସମ୍ଭାବନା ସମ୍ଭବ ହୁଏ।",
    "hero.subheading": "ବିଶେଷ ଶିକ୍ଷା, ଥେରାପି ସେବା ଏବଂ ସମଗ୍ର ବ୍ୟକ୍ତିତ୍ୱ ବିକାଶ — ଅନୁଭବୀ ଶିକ୍ଷକ ଓ ପ୍ରମାଣିତ ଥେରାପିଷ୍ଟଙ୍କ ଦ୍ୱାରା।",
    "hero.rating": "ରେଟିଂ",
    "hero.reviews": "ସମୀକ୍ଷା",
    "hero.statTherapies": "୫ ଥେରାପି କାର୍ଯ୍ୟକ୍ରମ",
    "hero.statYears": "ଭଦ୍ରକର ପରିବାରଙ୍କ ଭରସା",

    "about.title": "ପିତାମାତା କାହିଁକି ADHD ସ୍କୁଲକୁ ବିଶ୍ୱାସ କରନ୍ତି",
    "about.body": "ଆଚାର୍ଯ୍ୟ ଦେବ ଡେଭଲପମେଣ୍ଟ ହୋଲିଷ୍ଟିକ୍ ସ୍କୁଲ୍ ଭଦ୍ରକର ଶିଶୁମାନଙ୍କ ଶିକ୍ଷା, ଥେରାପି ଏବଂ ସମ୍ପୂର୍ଣ୍ଣ ବିକାଶ ପାଇଁ ସମର୍ପିତ ଅଗ୍ରଣୀ କେନ୍ଦ୍ର ମଧ୍ୟରୁ ଗୋଟିଏ। ଆମେ ବିଶ୍ୱାସ କରୁ ପ୍ରତ୍ୟେକ ଶିଶୁ ଅଦ୍ୱିତୀୟ।",
    "about.pillarsTitle": "ଆମେ ଯାହା ଉପରେ ଧ୍ୟାନ ଦେଉ",

    "services.title": "ଆମର ଥେରାପି ଓ ଶିକ୍ଷା ସେବା",
    "services.subtitle": "ଶିଶୁକୁ କେନ୍ଦ୍ର କରି ତିଆରି ୫ଟି ଯୋଜନା।",

    "principal.title": "ପ୍ରଧାନ ଶିକ୍ଷୟିତ୍ରୀଙ୍କୁ ଭେଟନ୍ତୁ",
    "principal.name": "ସ୍ୱସ୍ତି ପ୍ରଭା ଜେନା",
    "principal.role": "ପ୍ରଧାନ ଓ ସଂସ୍ଥାପକ",
    "principal.qualifications": "B.A., NTT, ନର୍ସିଂ ଟ୍ରେନ୍ଡ ଶିକ୍ଷୟିତ୍ରୀ",
    "principal.certs": "ADHD ମ୍ୟାନେଜମେଣ୍ଟ ଓ ଅଟିଜ୍ମ କେୟାରରେ ପ୍ରମାଣିତ",
    "principal.quote": "ଆମର ସ୍ୱପ୍ନ — ପ୍ରତ୍ୟେକ ଶିଶୁକୁ ସ୍ନେହ, ଯତ୍ନ ଏବଂ ସମ୍ପୂର୍ଣ୍ଣ ଶିକ୍ଷା ସହିତ ଗଢ଼ିବା।",

    "faq.title": "କାହିଁକି ପିତାମାତା ADHD ସ୍କୁଲ ଚୟନ କରନ୍ତି",
    "faq.subtitle": "ପ୍ରତ୍ୟେକ ପିତାମାତା ପଚାରୁଥିବା ପ୍ରଶ୍ନର ସତ୍ ଉତ୍ତର।",

    "reviews.title": "ପିତାମାତା କଣ କୁହନ୍ତି",
    "reviews.subtitle": "ଭଦ୍ରକର ପରିବାରଙ୍କ ସତ୍ ଅଭିଜ୍ଞତା।",

    "physio.eyebrow": "ଦ୍ୱିତୀୟ ବିଶେଷଜ୍ଞତା",
    "physio.title": "ଭଦ୍ରକ ଫିଜିଓଥେରାପି ଓ ରିହାବ୍ ସେଣ୍ଟର",
    "physio.tagline": "ସୁସ୍ଥ ସ୍ୱାସ୍ଥ୍ୟ ପାଇଁ ଯତ୍ନ, ଥେରାପି ଓ ପୁନର୍ବାସ",
    "physio.servicesTitle": "ଫିଜିଓଥେରାପି ସେବାସମୂହ",
    "physio.reviewsTitle": "ରୋଗୀଙ୍କ ସମୀକ୍ଷା",

    "doctor.title": "ଡାକ୍ତରଙ୍କୁ ଭେଟନ୍ତୁ",
    "doctor.name": "ଡାକ୍ତର ମନସ ରଞ୍ଜନ ଜେନା",
    "doctor.role": "କନସଲଟାଣ୍ଟ ଓ ପିତାମାତା କାଉନସେଲର",
    "doctor.description": "ଅଭିଜ୍ଞ ପରାମର୍ଶ ଓ ଦୟାଳୁ ଯତ୍ନ ସହିତ ସମଗ୍ର ପୁନର୍ବାସ।",

    "gallery.title": "ଆମ ସ୍କୁଲର ଝଲକ",
    "gallery.subtitle": "ଶିକ୍ଷା, ଥେରାପି ଓ ଆନନ୍ଦର ମୁହୂର୍ତ୍ତ।",

    "events.title": "ଅନୁଷ୍ଠାନ ଓ କାର୍ଯ୍ୟକ୍ରମ",
    "events.subtitle": "ୱର୍କଶପ, ସଚେତନତା ଶିବିର ଏବଂ ଉତ୍ସବ।",

    "contact.title": "ଆସନ୍ତୁ ଭେଟନ୍ତୁ",
    "contact.subtitle": "ଆମ କ୍ୟାମ୍ପସ ଭ୍ରମଣ ପାଇଁ ଆପଣଙ୍କୁ ସ୍ୱାଗତ।",
    "contact.address": "ବଣ୍ଠ ଛକ, ନେତାଜୀ ନଗର ରୋଡ, LIC ଅଫିସ ନିକଟ, ବାଗୁରାଇ, ଭଦ୍ରକ, ଓଡ଼ିଶା – 756100",
    "contact.phoneLabel": "ଫୋନ",
    "contact.addressLabel": "ଠିକଣା",
    "contact.hoursLabel": "ସମୟ",
    "contact.hours": "ସୋମ – ଶନି · 9:00 AM – 6:00 PM",

    "form.title": "ଆଡମିଶନ ପଚାରନ୍ତୁ",
    "form.subtitle": "ଆପଣଙ୍କ ଶିଶୁ ବିଷୟରେ କୁହନ୍ତୁ। ଆମେ ୨୪ ଘଣ୍ଟା ମଧ୍ୟରେ ଯୋଗାଯୋଗ କରିବୁ।",
    "form.name": "ପିତାମାତାଙ୍କ ନାମ",
    "form.phone": "ଫୋନ ନମ୍ବର",
    "form.email": "ଇମେଲ (ବିକଳ୍ପ)",
    "form.childAge": "ଶିଶୁର ବୟସ (ବିକଳ୍ପ)",
    "form.type": "ପ୍ରଶ୍ନ ପ୍ରକାର",
    "form.typeAdmission": "ସ୍କୁଲ ଆଡମିଶନ",
    "form.typePhysio": "ଫିଜିଓଥେରାପି",
    "form.typeGeneral": "ସାଧାରଣ ପ୍ରଶ୍ନ",
    "form.message": "ଆପଣଙ୍କ ସନ୍ଦେଶ",
    "form.success": "ଧନ୍ୟବାଦ! ଆମେ ଶୀଘ୍ର କଲ କରିବୁ।",
    "form.error": "କିଛି ତ୍ରୁଟି ହୋଇଛି। ସିଧାସଳଖ କଲ କରନ୍ତୁ।",

    "footer.quickLinks": "ଶୀଘ୍ର ଲିଙ୍କ",
    "footer.contact": "ଯୋଗାଯୋଗ କରନ୍ତୁ",
    "footer.copyright": "ସମସ୍ତ ଅଧିକାର ସଂରକ୍ଷିତ।",
    "footer.builtBy": "ଭଦ୍ରକର ଶିଶୁମାନଙ୍କ ପାଇଁ ଯତ୍ନ ସହିତ ତିଆରି।",
  },

  hi: {
    "brand.school": "आचार्य देव डेवलपमेंट होलिस्टिक स्कूल",
    "brand.short": "ADHD स्कूल",
    "brand.tagline": "शिक्षा, देखभाल और समग्र विकास के माध्यम से हर बच्चे को सशक्त बनाना",
    "brand.physio": "भद्रक फिजियोथेरेपी एवं रिहैब सेंटर",

    "nav.home": "होम",
    "nav.about": "हमारे बारे में",
    "nav.services": "सेवाएँ",
    "nav.principal": "प्रिंसिपल",
    "nav.physio": "फिजियोथेरेपी",
    "nav.doctor": "डॉक्टर",
    "nav.gallery": "गैलरी",
    "nav.events": "कार्यक्रम",
    "nav.contact": "संपर्क",
    "nav.enquire": "एडमिशन पूछताछ",

    "cta.enquire": "एडमिशन पूछताछ",
    "cta.call": "अभी कॉल करें",
    "cta.principal": "प्रिंसिपल से मिलें",
    "cta.doctor": "डॉ. मनस रंजन जेना से मिलें",
    "cta.location": "स्थान देखें",
    "cta.whatsapp": "व्हाट्सएप करें",
    "cta.directions": "दिशा-निर्देश",
    "cta.brochure": "ब्रोशर डाउनलोड",
    "cta.viewAll": "सब देखें",
    "cta.readMore": "और पढ़ें",
    "cta.submit": "भेजें",

    "hero.eyebrow": "भद्रक, ओडिशा",
    "hero.headline": "जहाँ हर बच्चे की क्षमता संभावना बन जाती है।",
    "hero.subheading": "विशेष शिक्षा, थेरपी सेवाएँ और समग्र व्यक्तित्व विकास — अनुभवी शिक्षकों और प्रमाणित थेरेपिस्टों के नेतृत्व में।",
    "hero.rating": "रेटिंग",
    "hero.reviews": "समीक्षाएँ",
    "hero.statTherapies": "5 थेरपी कार्यक्रम",
    "hero.statYears": "भद्रक के परिवारों का विश्वास",

    "about.title": "क्यों माता-पिता ADHD स्कूल पर भरोसा करते हैं",
    "about.body": "आचार्य देव डेवलपमेंट होलिस्टिक स्कूल भद्रक के बच्चों की शिक्षा, थेरपी और समग्र विकास के लिए समर्पित अग्रणी केंद्रों में से एक है। हम मानते हैं कि हर बच्चा अद्वितीय है।",
    "about.pillarsTitle": "हम किस पर ध्यान देते हैं",

    "services.title": "हमारी थेरपी और शिक्षा सेवाएँ",
    "services.subtitle": "बच्चे को केंद्र में रखकर डिज़ाइन किए गए 5 कार्यक्रम।",

    "principal.title": "हमारी प्रिंसिपल से मिलें",
    "principal.name": "स्वस्ति प्रवा जेना",
    "principal.role": "प्रिंसिपल एवं संस्थापिका",
    "principal.qualifications": "B.A., NTT, नर्सिंग ट्रेन्ड टीचर",
    "principal.certs": "ADHD प्रबंधन और ऑटिज्म सपोर्ट में प्रमाणित",
    "principal.quote": "हमारा सपना हर बच्चे को प्रेम, देखभाल और समग्र शिक्षा से सशक्त बनाना है।",

    "faq.title": "क्यों माता-पिता ADHD स्कूल चुनते हैं",
    "faq.subtitle": "वही प्रश्न जो हर माता-पिता पूछते हैं — ईमानदारी से उत्तर।",

    "reviews.title": "अभिभावक क्या कहते हैं",
    "reviews.subtitle": "भद्रक के परिवारों की सच्ची कहानियाँ।",

    "physio.eyebrow": "दूसरी विशेषज्ञता",
    "physio.title": "भद्रक फिजियोथेरेपी एवं रिहैब सेंटर",
    "physio.tagline": "बेहतर स्वास्थ्य के लिए देखभाल, थेरपी और पुनर्वास",
    "physio.servicesTitle": "फिजियोथेरेपी सेवाएँ",
    "physio.reviewsTitle": "मरीज़ों की समीक्षा",

    "doctor.title": "डॉक्टर से मिलें",
    "doctor.name": "डॉ. मनस रंजन जेना",
    "doctor.role": "कन्सल्टेंट एवं पैरेंट काउंसलर",
    "doctor.description": "विशेषज्ञ परामर्श और करुणामय देखभाल के साथ समग्र पुनर्वास।",

    "gallery.title": "हमारे स्कूल की झलक",
    "gallery.subtitle": "शिक्षा, थेरपी और खुशी के पल।",

    "events.title": "कार्यक्रम और गतिविधियाँ",
    "events.subtitle": "वर्कशॉप, जागरूकता शिविर और उत्सव।",

    "contact.title": "हमसे मिलें",
    "contact.subtitle": "कैम्पस विज़िट के लिए आपका स्वागत है।",
    "contact.address": "बोंथ छक, नेताजी नगर रोड, LIC ऑफिस के पास, बागुराई, भद्रक, ओडिशा – 756100",
    "contact.phoneLabel": "फ़ोन",
    "contact.addressLabel": "पता",
    "contact.hoursLabel": "समय",
    "contact.hours": "सोम – शनि · 9:00 AM – 6:00 PM",

    "form.title": "एडमिशन पूछताछ",
    "form.subtitle": "अपने बच्चे के बारे में बताएँ। हम एक कार्यदिवस में संपर्क करेंगे।",
    "form.name": "अभिभावक का नाम",
    "form.phone": "फ़ोन नंबर",
    "form.email": "ईमेल (वैकल्पिक)",
    "form.childAge": "बच्चे की उम्र (वैकल्पिक)",
    "form.type": "पूछताछ का प्रकार",
    "form.typeAdmission": "स्कूल एडमिशन",
    "form.typePhysio": "फिजियोथेरेपी",
    "form.typeGeneral": "सामान्य प्रश्न",
    "form.message": "आपका संदेश",
    "form.success": "धन्यवाद! हम जल्द ही कॉल करेंगे।",
    "form.error": "कुछ गड़बड़ हुई। कृपया सीधे कॉल करें।",

    "footer.quickLinks": "त्वरित लिंक",
    "footer.contact": "संपर्क",
    "footer.copyright": "सर्वाधिकार सुरक्षित।",
    "footer.builtBy": "भद्रक के बच्चों के लिए प्रेम से बनाया गया।",
  },
};
